function fileNameValidator(fileName: string){
    // Xóa bỏ các dấu cách và thay thế bằng gạch dưới hoặc gạch ngang
    return fileName.trim().replace(/\s+/g, '_').replace(/[^a-zA-Z0-9._-]/g, '');
};
export default fileNameValidator;